import { Outlet } from "react-router";

/**
 * Authenticated layout — renders the main content area for protected routes.
 *
 * The sidebar, navigation, and user language providers are handled by AppShell
 * (which wraps all routes). This layout exists as an Outlet wrapper so that
 * React Router's nested route structure works correctly with AuthGuard.
 *
 * In a later task (directory restructure), AppShell's authenticated content
 * will move here directly.
 */
export default function AuthenticatedLayout() {
  return <Outlet />;
}
